import { render, staticRenderFns } from "./TabelaResultadosMeusPendentes.vue?vue&type=template&id=b4208a40&scoped=true&"
import script from "./TabelaResultadosMeusPendentes.vue?vue&type=script&lang=js&"
export * from "./TabelaResultadosMeusPendentes.vue?vue&type=script&lang=js&"
import style0 from "./TabelaResultadosMeusPendentes.vue?vue&type=style&index=0&id=b4208a40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4208a40",
  null
  
)

export default component.exports